<template>
  <v-card v-if="jobItem" @click.native.stop="!noclick ? select(jobItem) : null" class="jobitem"
    :class="[jobItem.odd ? 'oddcolored' : 'evencolored', selected ? 'selectedIndicator' : '', hover ? 'hoverIndicator' : '']"
    elevation="0" @click.middle.exact="openInNewTab()"
    @dblclick="!noclick ? $router.push({ name: 'ViewJob', params: { filter: 'my', jobId: jobItem.Id } }) : null"
    @mouseover="(e) => $emit('mouseover', e)">
    <v-container fluid class="pa-0">
      <v-row no-gutters align="center" class="maprow d-flex flex-nowrap" style="overflow-x: none">
        <v-col>
          <v-list class="py-0">
            <v-list-item v-if="showAddress && jobItem && jobItem.DeliveryAddress" dense class="px-3"
              style="min-height: 36px;">
              <v-list-item-action class="ma-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon @click="openInMaps(jobItem)" small>
                      <v-icon size="18">mdi-map-marker</v-icon>
                    </v-btn>
                  </template>
                  <span>View on map</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-content class="py-1">
                <HoverMenu :width="'280px'" :nudgeamount="13" direction="top" :delay="500">
                  <template v-slot:menu-activator>
                    <v-list-item-title class="mb-n1">
                      {{ [jobItem.DeliveryAddress.Street, jobItem.DeliveryAddress.Zip, jobItem.DeliveryAddress.City,
                      jobItem.DeliveryAddress.Country].filter(Boolean).join(', ') }}
                    </v-list-item-title>
                  </template>
                  <template v-slot:menu-content>
                    <adress-li :noname="true" :value="jobItem.DeliveryAddress">
                    </adress-li>
                  </template>
                </HoverMenu>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col v-if="multiselectmode" cols="auto" class="d-flex align-center">
          <v-checkbox v-model="checked" hide-details class="mt-0">
          </v-checkbox>
        </v-col>
        <v-col>
          <v-list dense class="py-0 transparent sumo">
            <v-list-item font-weight-black :style="!hasMalformedOrderId(jobItem) ? '' :
              'border: 1px solid rgb(255, 130, 6); background-color: rgba(255, 130, 6, 0.07);'"
              :three-line="!JobListViewOptions.includes('Compact') && !(!jobItem.FirstLineComment || jobItem.FirstLineComment == '')"
              link class="darkerheader">
              <v-list-item-icon class="uplifted mr-4">
                <div v-if="hasMalformedOrderId(jobItem)"
                  style="position: absolute; top: -9px; left: 15px; z-index: 10;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" size="14" color="warning" v-text="'mdi-alert'" />
                    </template>
                    <span>{{ $t('servicesystem.common_objects.fallbackterms.malformed_order_id') }}</span>
                  </v-tooltip>
                </div>
                <v-icon v-if="!showStatus" color="primary" size="20" v-text="'$job'" />
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="20" color="primary" v-text="statusicon(jobItem.StatusId)" />
                  </template>
                  <span>{{ jobItem.StatusName }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="d-flex">
                  <div v-html="jobItem.DisplayName" class="useThemeTextColor nowrapheader font-weight-bold" />
                  <v-spacer />
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="mr-2"
                        style="color: #888888 !important; font-size: 0.9em !important;"
                        v-text="createdDateDisplayText" />
                    </template>
                    <span>{{ i18nFormatDateTime(jobItem.CreatedDate) }}</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle class="d-flex">
                  <div v-html="jobItem.JobTypeName" class="useThemeTextColor nowrapheader" />
                  <v-spacer />
                  <div class="mr-2" style="font-size: 0.9em !important;" :class="prioritycolor"
                    v-html="jobItem.JobPriority && jobItem.JobPriority.Name" />
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="(jobItem.FirstLineComment && jobItem.FirstLineComment != '')"
                  class="d-flex align-center pa-1 mt-1 rounded-sm"
                  :class="(jobItem.Appointments && jobItem.Appointments[0]) || (jobItem.Jobs && jobItem.Jobs.some(x => x.JobStatusId != 110)) ? 'flc-vertical-line-extencion' : ''"
                  style="color: var(--v-dark-text-base) !important; background-color: var(--v-firstlineCommentBackground-base);">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" class="mr-2" size="18">mdi-exclamation-thick</v-icon>
                    </template>
                    <span>{{ $t('servicesystem.common_objects.job.first_line_comment') }}</span>
                  </v-tooltip>
                  {{ jobItem.FirstLineComment }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="ml-0">
                <double-click-hint v-if="!previewMode"></double-click-hint>
              </v-list-item-action>
            </v-list-item>

            <div class="child-indent">

              <!--Machines -------------------------------->
              <template v-if="showMachines">
                <template v-for="entry in jobItem.Jobs">
                  <v-list-item v-if="entry.JobStatusId != 110" :key="entry.routeName"
                    :three-line="!JobListViewOptions.includes('Compact')" :ripple="false" style=""
                    :style="!hasMalformedOrderId(entry) ? '' :
                      'border: 1px solid rgb(255, 130, 6); border-left: none; background-color: rgba(255, 130, 6, 0.07);'" class="vertical-line" @click.stop="!noclick ? select(jobItem) : null">
                    <v-list-item-icon class="horizontal-line mr-3">
                      <div v-if="hasMalformedOrderId(entry)"
                        style="position: absolute; top: -6px; left: 14px; z-index: 10;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" size="14" color="warning" v-text="'mdi-alert'" />
                          </template>
                          <span>{{ $t('servicesystem.common_objects.fallbackterms.malformed_order_id') }}</span>
                        </v-tooltip>
                      </div>
                      <FlagIconWrapper :flag="entry.Flag">
                        <v-icon size="22" color="primary" v-text="'$machine'">
                        </v-icon>
                      </FlagIconWrapper>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-html="entry.MachineName" class="mb-2" style="" />
                      <v-list-item-subtitle style="background-color: rgba(0, 0, 0, 0.03); padding: 5px;"
                        class="d-flex align-center rounded-sm v--dark-text">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="mr-2" size="18">mdi-comment-account-outline</v-icon>
                          </template>
                          <span>{{ $t('servicesystem.common_objects.machine.edit.customer_comment') }}</span>
                        </v-tooltip>
                        {{ entry.CustomerComment }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="entry.InvoiceComment"
                        class="d-flex align-center pa-1 v--dark-text rounded-sm"
                        style="background-color: var(--v-invoiceCommentBackground-base);">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="mr-2" size="18">mdi-cash-multiple</v-icon>
                          </template>
                          <span>{{ $t('servicesystem.common_objects.machine.edit.invoice_comment') }}</span>
                        </v-tooltip>
                        {{ entry.InvoiceComment }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </template>

              <!--Appointments -------------------------------->
              <template v-if="showAppointments">
                <v-list-item v-for="entry in jobItem.Appointments" :key="entry.routeName" :ripple="false"
                  class="vertical-line" @click.stop="!noclick ? select(jobItem) : null"
                  @dblclick.stop="!noclick ? $router.push({ name: 'ViewJobPlanning', params: { filter: 'my', jobId: jobItem.Id, appointmentId: entry.Id } }) : null">
                  <v-list-item-icon class="horizontal-line mr-3">
                    <v-icon :color="progressColor(entry)" size="20" v-text="'$appointment'" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="d-flex mr-2">
                      <div v-text="participantsHeader(entry.Participants)" class="nowrapheader" />
                      <v-spacer />
                      <span :class="progressColor(entry) + '--text'">
                        {{ (inProgress(entry) === 0) ? $t('servicesystem.common_objects.appointment.in_progress') :
                          fromNow(entry.StartTime) }}
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <double-click-hint v-if="!previewMode"></double-click-hint>
                </v-list-item>
              </template>
            </div>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DoubleClickHint from "@/components/Buttons/DoubleClickHint.vue";
import FlagIconWrapper from "@/components/Buttons/FlagIconWrapper.vue";
import AdressLi from "@/components/Inputs/AdressListItem.vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";
//import CustomSimpleStepper from "@/components/ListItems/JobListItem/CustomSimpleStepper.vue";

export default {
  name: "JobListItem",
  props: {
    selected: Boolean,
    hover: Boolean,
    jobItem: Object,
    previewMode: Boolean,
    showStatus: Boolean,
    multiselectmode: Boolean,
    noclick: Boolean,
    showDateStepper: Boolean,
    showAddress: Boolean,
    navDisabled: Boolean,
  },
  components: {
    DoubleClickHint,
    FlagIconWrapper,
    HoverMenu,
    AdressLi,
    //CustomSimpleStepper,
  },
  mixins: [clientAPI],

  data() {
    return {
      checked: false,
    };
  },
  methods: {
    select(item) {
      this.$emit('click',item)
      if (this.navDisabled) {
        return;
      }
      if (this.previewMode) {
        this.openInNewTab();
      }
      else {
        var currentroute = this.$route;
        if (!this.selected) {
          this.$store.state.triggerevents.previewTrigger++;
          currentroute.params.jobId = item.Id;
          this.$router.replace(currentroute);
        } else {
          this.$store.state.triggerevents.previewTrigger++;
          if (!this.isPhoneBool) {
            currentroute.params.jobId = undefined;
            this.$router.replace(currentroute);
          }
        }
      }
    },

    openInNewTab() {
      if (!this.noclick) {
        let newPageRoute = this.$router.resolve({ name: "ViewJob", params: { filter: 'my', jobId: this.jobItem.Id } });
        window.open(newPageRoute.href, "_blank");
      }
    },

    participantsHeader(list) {
      if (list && list.length > 1) {
        return "" + list.length + " " + this.$t("servicesystem.common_objects.appointment.participants");
      } else if (list && list.length === 1) {
        return list[0].Name ? list[0].Name : "unnamed participant";
      } else {
        return "No participants";
      }
    },

    changeStatus(divId) {
      if (divId && divId.includes("status/")) {
        var split2 = divId.split("/substatus/");
        var split = split2[0].split("status/");
        const substatus = split2[1];
        const status = split[1];

        clientAPI.methods.SetJobStatus(this.jobItem.Id, status, substatus).then(() => {
          this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
          this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
        });
      }
    },

    openInMaps(job) {
      var address = job.DeliveryAddress;
      var street = address.Street ? encodeURIComponent(address.Street) : null;
      var city = address.City ? encodeURIComponent(address.City) : null;
      var zip = address.Zip ? encodeURIComponent(address.Zip) : null;
      var country = address.Country ? encodeURIComponent(address.Country) : null;
      var query = [street, city, zip, country].filter(Boolean).join("%2C");
      //console.log([street, city, zip, country], query);
      window.open("https://www.google.com/maps/search/?api=1&query=" + query, "_blank");
    }
  },

  computed: {

    JobListViewOptions() {
      return this.$store.getters["prefrences/Prefrence"]("JobListViewOptions");
    },

    showMachines() {
      return this.JobListViewOptions ? this.JobListViewOptions.includes("Machines") : false;
    },

    showAppointments() {
      return this.JobListViewOptions ? this.JobListViewOptions.includes("Appointments") : true;
    },

    createdDateDisplayText() {
      var indate = this.jobItem.CreatedDate;
      var date = this.getDateFromString(indate);
      if (this.isToday(date)) {
        return this.i18nFormatTime(indate) + ' ' + this.$t('servicesystem.common_objects.commonterms.today')
      }
      /*
      else if (this.isYesterday(date)) {
        return this.i18nFormatTime(indate) + ' ' + this.$t('servicesystem.common_objects.commonterms.yesterday')
      }
      */
      else {
        return this.i18nFormatDate(date)
      }

    },

    remainingTime() {
      var result;
      if (this.jobItem.daysAgo && this.jobItem.JobPriority) {
        result = this.jobItem.JobPriority.DueAfterHours - this.jobItem.daysAgo * 24;
      } else if (this.jobItem.JobPriority) {
        result = this.jobItem.JobPriority.DueAfterHours - this.jobItem.hoursAgo;
      }
      return result;
    },

    prioritycolor() {
      var result;
      if (this.remainingTime < 0) {
        result = "error--text";
      } else if (this.remainingTime < /*this.jobItem.JobPriority.DueAfterHours / 2*/ 24) {
        result = "tertiary--text";
      } else {
        result = "";
      }

      return result;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.jobitem {
  border-bottom: 1px solid #959595;
}

.transparent {
  background-color: transparent;
}

.darkerheader {
  background-color: rgba(0, 0, 0, 0.03);
}

.evencolored,
.oddcolored {
  border-radius: 0 !important;
  padding: 1px 0;
}

.hoverIndicator {
  border: 1px solid #427aaf;
  border-left: 7px solid #427aaf;
  border-right: none;
  padding: 0 !important;
}

.selectedIndicator {
  border: 1px solid var(--v-tertiary-base);
  border-left: 7px solid var(--v-tertiary-base);
  border-right: none;
  padding: 0 !important;
}

.OddMarkedList>div:nth-child(odd):not(.li-header):not(.ignoreodd),
.OddMarkedList>div:nth-child(odd):not(.li-header):not(.ignoreodd)>div.jobitem {
  background-color: var(--v-list-odd-marked-base);
}

.uplifted {
  position: relative;
  z-index: 4;
}

.selectedIndicator .darkerheader,.hoverIndicator .darkerheader {
  padding-left: 9px;
}

/*Inherentence indicator lines*/
.child-indent {
  position: relative;
  margin-left: 26px;
}

.selectedIndicator .child-indent,.hoverIndicator .child-ident,.hoverIndicator .child-indent,.hoverIndicator .child-ident {
  margin-left: 19px;
}

.horizontal-line {
  position: relative;
}

.horizontal-line::after,
.vertical-line::after,
.flc-vertical-line-extencion::before {
  content: "";
  position: absolute;
  border-radius: 3px;
  z-index: 3;
  min-height: unset;
  width: 3px;
  background-color: rgb(208, 208, 208);
}

.horizontal-line::after {
  height: 3px;
  width: 13px !important;
  top: 40%;
  left: -16px;
}

.vertical-line::after {
  height: 40px;
  top: -20px;
  left: 0px;
}

.vertical-line:not(:last-child)::after {
  height: calc(100% + 20px) !important;
}

.flc-vertical-line-extencion::before {
  height: calc(100% - 30px);
  top: 30px;
  left: 26px;
}

.selectedIndicator .flc-vertical-line-extencion::before, 
.hoverIndicator .flc-vertical-line-extencion::before {
  left: 19px !important;
}

.maprow {
  background-color: #0000000f;
}
</style>